import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap, take, tap } from 'rxjs/operators';

import { AuthService } from '../../pages/auth/auth.service';
import { AUTH_PATHS, AuthUserName } from '../../pages/auth/auth';
import { isLegacyLoginEnabled } from '../../../environments/legacy-login';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: false,
})
export class TopbarComponent implements OnInit {
  public AUTH_PATHS = AUTH_PATHS;
  public isUserAuthorized: boolean;
  public employee: AuthUserName;
  public isLegacyLoginVisible = isLegacyLoginEnabled();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.authService.subscribeAuthData().subscribe((authData) => {
      this.isUserAuthorized = authData.isLoggedIn;
      this.employee = authData.employee;
    });
  }

  public logout() {
    this.authService
      .subscribeAuthData()
      .pipe(
        take(1),
        switchMap(({ loggedByMobileId }) => {
          return this.authService.logout().pipe(
            tap(() => {
              if (loggedByMobileId) {
                this.router.navigate(['/auth/logout']);
              } else {
                localStorage.setItem('logout', Math.random() + '');
                this.router.navigate(['/' + (isLegacyLoginEnabled() ? AUTH_PATHS.login_legacy : AUTH_PATHS.login)]);
              }
            })
          );
        })
      )
      .subscribe();
  }
}
